const audio = new Audio('../../../assets/error.mp3');
export function playError() {
    audio.play();
}
